import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

import { FormCheckbox } from './form.checkbox';
import { FormComboboxTagInput } from './form.combobox-tag-input';
import { FormDateRangeField } from './form.date-range-field';
import { FormInputGroupInput } from './form.input-group';
import { FormLabelGroup } from './form.label-group';
import { FormRadioGroup } from './form.radio-group';
import { FormRoot } from './form.root';
import { FormSelect } from './form.select';
import { FormStructuredFilter } from './form.structured-filter';
import { FormSubscribeButton } from './form.submit-button';
import { FormSwitch } from './form.switch';
import { FormTabs } from './form.tabs';
import { FormTagInput } from './form.tag-input';
import { FormTextField } from './form.text-field';
import { FormTextarea } from './form.textarea';
import { FormToggle } from './form.toggle';
import { FormToggleGroup, FormToggleGroupMultiple } from './form.toggle-group';

// Create contexts
export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

// Field components
const TextField = FormTextField;
const Textarea = FormTextarea;
const Select = FormSelect;
const Checkbox = FormCheckbox;
const RadioGroup = FormRadioGroup;
const Switch = FormSwitch;
const Tabs = FormTabs;
const LabelGroup = FormLabelGroup;
const Toggle = FormToggle;
const ToggleGroup = FormToggleGroup;
const ToggleGroupMultiple = FormToggleGroupMultiple;
const InputGroupInput = FormInputGroupInput;
const TagInput = FormTagInput;
const ComboboxTagInput = FormComboboxTagInput;
const StructuredFilter = FormStructuredFilter;
const DateRangeField = FormDateRangeField;

// Form components
const Root = FormRoot;
const SubscribeButton = FormSubscribeButton;

// Create form hook
const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    Textarea,
    Select,
    Checkbox,
    RadioGroup,
    Switch,
    Tabs,
    LabelGroup,
    Toggle,
    ToggleGroup,
    ToggleGroupMultiple,
    InputGroupInput,
    TagInput,
    ComboboxTagInput,
    StructuredFilter,
    DateRangeField,
  },
  formComponents: {
    Root,
    SubscribeButton,
  },
});

export { useAppForm, withFieldGroup,withForm };
